import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import adminApiClient from 'api/adminApiClient';

interface DashboardState {}

const initialState: DashboardState = {};

const getTotalNumbers = createAsyncThunk(
  'dashboard/getTotalNumbers',
  async () => {
    return adminApiClient.getTotalNumbers();
  },
);

const getPendingCustomerRequests = createAsyncThunk(
  'dashboard/getPendingCustomerRequests',
  async () => {
    return adminApiClient.getPendingCustomersRequests(undefined);
  },
);

const getPendingAssignmentRequests = createAsyncThunk(
  'dashboard/getPendingAssignmentRequests',
  async () => {
    return adminApiClient.getPendingAssignmentRequests();
  },
);

const getHomepageStatistics = createAsyncThunk(
  'dashboard/getHomepageStatistics',
  async () => {
    return adminApiClient.getHomepageStatistics();
  },
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
});

const { reducer } = dashboardSlice;

export {
  getTotalNumbers,
  getPendingCustomerRequests,
  getPendingAssignmentRequests,
  getHomepageStatistics,
};
export default reducer;
